export const statisticModel = {
  data: {
    today: {
      title: 'сегодня',
      method: 'getTodayTrust',
      data: {
        total: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
        positive: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
        netural: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
        negative: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
      },
    },
    weak: {
      title: 'неделя',
      method: 'getWeekTrust',
      data: {
        total: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
        positive: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
        netural: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
        negative: {
          posts: 0,
          likes: 0,
          reposts: 0,
        },
      },
    },
  },
  current: 'weak',
};
